module.exports = __webpack_public_path__ + "static/immersionbackground-af893ca489773aea56a69a74246f4272.png";